import { GridColDef } from '@mui/x-data-grid';

import { RenderCellParams, ValueGetterParams } from './gridColumnDefinitions';
import {
  mediumWidth,
  smallWidth,
  ageWidth,
  largeWidth,
} from '../../../Constants';
import { numberToStringWithCommas } from '../../../helpers/NumberFormatting';
import {
  getIntelAgeWithToolTip,
  hoursMinutesFromSeconds,
  numberWithCommasComparator,
} from '../helpers/colHelpers';

export const armyGridColDefinitions: GridColDef[] = [
  { field: 'id', headerName: 'id_army', width: 20 },
  { field: 'pid', headerName: '#', width: 20 },
  {
    field: 'name',
    headerName: 'Name',
    width: 200,
    sortable: false,
    valueGetter: (params: ValueGetterParams) => params.row.name,
  },
  {
    field: 'secondsRemaining',
    headerName: 'TimeRemaining',
    width: 90,
    sortable: false,
    valueGetter: (params: ValueGetterParams) => params.row.secondsRemaining,
    renderCell: (params: RenderCellParams) =>
      hoursMinutesFromSeconds(params.row.secondsRemaining),
  },
  {
    field: 'acres',
    headerName: 'Acres',
    width: mediumWidth,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.land),
    sortComparator: numberWithCommasComparator,
  },
  {
    field: 'ambush',
    headerName: 'Ambush',
    width: largeWidth,
    sortable: false,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.ambush),
  },
  {
    field: 'generals',
    headerName: 'Gen',
    width: smallWidth,
    sortable: false,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.generals),
  },
  {
    field: 'soldiers',
    headerName: 'Solds',
    width: mediumWidth,
    sortable: false,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.solds),
  },
  {
    field: 'oSpecs',
    headerName: 'OSpecs',
    width: mediumWidth,
    sortable: false,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.oSpecs),
  },
  {
    field: 'Elites',
    headerName: 'Elites',
    width: mediumWidth,
    sortable: false,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.elites),
  },
  {
    field: 'Horses',
    headerName: 'Horses',
    width: mediumWidth,
    sortable: false,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.horses),
  },
  {
    field: 'rawOff',
    headerName: 'RawOff',
    width: ageWidth,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.rawOff),
  },
  {
    field: 'modOff',
    headerName: 'ModOff',
    width: ageWidth,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.modOff),
  },
  {
    field: 'rawDef',
    headerName: 'RawDef',
    width: ageWidth,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.rawDef),
  },
  {
    field: 'modDef',
    headerName: 'ModDef',
    width: ageWidth,
    valueGetter: (params: ValueGetterParams) =>
      numberToStringWithCommas(params.row.modDef),
  },
  {
    field: 'somAge',
    headerName: 'SomAge',
    width: ageWidth,
    renderCell: (params: RenderCellParams) =>
      getIntelAgeWithToolTip(params.row.ageSeconds, 'SOM'),
  },
];
